export default class ApplicationTab {
  static readonly APPLIED = "applied";
  static readonly EVALUATED = "evaluated";
  static readonly CANCELED = "canceled";
  static readonly ATTENDANCE = "attendance";
  static readonly NOT_EVALUATED = "notEvaluated";
}
